module.exports = __webpack_public_path__ + "img/caeroon-gallery-thegem-portfolio-masonry-16.6437ca38.jpg";